import { useLang } from '../../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../../hooks/use-modal-params';
import { TreeNodeType } from '../../../../../../../store/api/trees-api';
import { useInputLangStore } from '../../../../../../../store/use-input-lang-store';
import { useTreeStore } from '../../../../../../../store/use-tree-store';

export const useTreeStructureNode = (node: Partial<TreeNodeType>) => {
  const { handleUpdateNode, handleResetNode, node: activeNode } = useTreeStore();
  const { getLocale } = useLang();
  const { language } = useInputLangStore();
  const name = getLocale(node.name, language);

  const handleDeleteNode = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleOpenModal({ name, deleteId: node.id || '' });
  };

  const isActive = activeNode?.id === node.id;

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleResetNode();
    handleUpdateNode(node);
  };

  const { handleOpenModal } = useModalParams('deleteNode');

  return { isActive, handleEdit, handleDeleteNode, name };
};
